import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import EmptyState from '../../../../EmptyState';
import {
  withVerification,
  WithVerificationProps,
} from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import {
  withLogBiEvent,
  WithLogBiEventProps,
} from '@wix/da-shared-react/pkg/biLogger/hocs/withLogBiEvent';
import { VerificationRequiredActions } from '@wix/da-shared-react/pkg/publicSession/types';
import noop from '@wix/da-shared-react/pkg/utils/noop';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger/constants';
import { PostsType } from '../../../../../../types/posts';
import { CTAModalsMap } from './constants';

import s from './EmptyState.scss';

export interface Props {
  postType: PostsType | 'featuredJournal' | 'featuredPosts';
  view?: 'large' | 'small' | 'wide';
  isOwner: boolean;
  username?: string;
  className?: string;
  openSubmitPostPopup?: () => void;
}

export class PostsEmptyState extends React.Component<
  Props & WithTranslation & WithVerificationProps & WithLogBiEventProps
> {
  render() {
    const { view, isOwner, username, postType, className, t } = this.props;

    return (
      <EmptyState
        view={view}
        className={classnames(
          s['root'],
          view === 'large' && s['large'],
          className
        )}
        title={
          isOwner
            ? t!(`pages.posts.emptyState.${postType}.title.owner`)
            : t!(`pages.posts.emptyState.${postType}.title.visitor`, {
                username,
              })
        }
        subtitle={
          isOwner
            ? t!(`pages.posts.emptyState.${postType}.subtitle.owner`)
            : t!(`pages.posts.emptyState.${postType}.subtitle.visitor`, {
                username,
              })
        }
        buttonLabel={
          CTAModalsMap[postType] &&
          t!(`pages.posts.emptyState.${postType}.createCTA`)
        }
        onButtonClick={this.handleButtonClick}
        withButton={isOwner}
      />
    );
  }

  getVerificationPopupType(): VerificationRequiredActions {
    const { postType } = this.props;
    switch (postType) {
      case 'journals':
      case 'drafts':
        return 'submitjournal';
      case 'polls':
        return 'submitpoll';
      case 'statuses':
        return 'submitstatus';
      default:
        return 'submit';
    }
  }

  handleButtonClick = () => {
    const {
      postType,
      logBiEvent,
      pushVerificationPopup,
      isVerificationNeeded,
      openSubmitPostPopup = noop,
    } = this.props;

    if (!CTAModalsMap[postType]) {
      return null;
    }

    if (isVerificationNeeded) {
      pushVerificationPopup(this.getVerificationPopupType());
    } else {
      openSubmitPostPopup();
      logBiEvent({
        evid: BiEventType.ADD_NEW_CONTENT_CLICK,
        widgetname: `${postType}_emptystate`,
      });
    }
  };
}

const enhance = compose(withVerification, withLogBiEvent, withTranslation());

export default enhance(PostsEmptyState);
